module.exports = __webpack_public_path__ + "static/media/modalMarcaPonto.9ace69ea.jpg";